import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PreviewPdfFile from '../../../components2/PreviewPdfFile';
import { isWordFile } from '../../../utils/filePreview';

const PreviewFiles = ({ id, url }) => {
  const [isImageValid, setIsImageValid] = useState(null);

  useEffect(() => {
    setIsImageValid(null);
    if (isWordFile(url) || /\.pdf(?:[?#]|$)/i.test(url || '')) {
      setIsImageValid(false);
      return;
    }
    const checkImgUrl = new window.Image();
    checkImgUrl.onload = () => setIsImageValid(true);
    checkImgUrl.onerror = () => setIsImageValid(false);
    checkImgUrl.src = url;
    return () => { checkImgUrl.onload = null; checkImgUrl.onerror = null; };
  }, [url]);

  if (isImageValid == null) return <div role="status">Loading document preview…</div>;

  return isImageValid ? (
    <PreviewImg key={id} id={id} src={url} />
  ) : (
    <PreviewPdfFile url={url} />
  );
};

export default PreviewFiles;

export const PreviewImg = styled.img`
  width: 100%;
`;
